import React from 'react'
import { useTranslation } from 'react-i18next'

const MyQuestionnaireLayout = () => {
  const { t } = useTranslation()

  return <h1>{t('Questionnaire.My.PageHeader')}</h1>
}

export default MyQuestionnaireLayout
